module.exports = __webpack_public_path__ + "video_icon.3969b4be.png";